import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { GrodnoRegionWithLoader } from './loaders';
import { getCitiesByRegion } from '../../../actions/city/thunks';
import { RegionTypes } from '../../../types/Models/City/City';

export const GrodnoRegion = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCitiesByRegion(RegionTypes.GRODNO));
    }, []);

    return <GrodnoRegionWithLoader />;
};
